import React from 'react';
import { Box, Divider, Stack, Typography, Tooltip } from '@mui/material';
import { Home, Person, FlightLand, FlightTakeoff, MeetingRoom } from '@mui/icons-material';

export default function StatsBar({ statistics, pmsColors, showAdvancedMetrics }) {
  // Use pmsColors if available, otherwise fallback is tricky so we assume it is passed.
  // The parent RoomsCalendarLite.js passes it.

  if (!pmsColors) return null;

  return (
    <Stack direction="row" spacing={{ xs: 2, md: 4 }} alignItems="center" sx={{ width: '100%', overflowX: 'auto' }}>
      {/* Rooms Overview */}
      <Tooltip title="Total Habitaciones">
        <Stack direction="row" spacing={1} alignItems="center">
          <Home sx={{ fontSize: 18, color: pmsColors.text.disabled }} />
          <Typography variant="body2" color={pmsColors.text.secondary}>
            <Box component="span" sx={{ fontWeight: 700, color: pmsColors.text.primary }}>
              {statistics.totalRooms}
            </Box>{' '}
            Total
          </Typography>
        </Stack>
      </Tooltip>

      <Divider orientation="vertical" flexItem sx={{ height: 16 }} />

      {/* Occupancy Status */}
      <Stack direction="row" spacing={3}>
        <Stack direction="row" spacing={1} alignItems="center">
          <Box sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: pmsColors.rooms.occupied }} />
          <Typography variant="body2" color={pmsColors.text.secondary}>
            <Box component="span" sx={{ fontWeight: 700, color: pmsColors.text.primary }}>
              {statistics.occupiedRooms}
            </Box>{' '}
            Ocupadas
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1} alignItems="center">
          <Box sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: pmsColors.rooms.vacant_clean }} />
          <Typography variant="body2" color={pmsColors.text.secondary}>
            <Box component="span" sx={{ fontWeight: 700, color: pmsColors.text.primary }}>
              {statistics.availableRooms}
            </Box>{' '}
            Disp.
          </Typography>
        </Stack>
      </Stack>

      <Divider orientation="vertical" flexItem sx={{ height: 16 }} />

      {/* Operations */}
      <Stack direction="row" spacing={3}>
        <Stack direction="row" spacing={1} alignItems="center">
          <FlightLand sx={{ fontSize: 16, color: pmsColors.reservations.checked_in }} />
          <Typography variant="body2" color={pmsColors.text.secondary}>
            <Box component="span" sx={{ fontWeight: 700, color: pmsColors.text.primary }}>
              {statistics.arrivals}
            </Box>{' '}
            Llegadas
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1} alignItems="center">
          <FlightTakeoff sx={{ fontSize: 16, color: pmsColors.reservations.checked_out }} />
          <Typography variant="body2" color={pmsColors.text.secondary}>
            <Box component="span" sx={{ fontWeight: 700, color: pmsColors.text.primary }}>
              {statistics.departures}
            </Box>{' '}
            Salidas
          </Typography>
        </Stack>
      </Stack>

      {showAdvancedMetrics && (
        <>
          <Divider orientation="vertical" flexItem sx={{ height: 16 }} />
          <Stack direction="row" spacing={1} alignItems="center">
            <Person sx={{ fontSize: 18, color: pmsColors.text.disabled }} />
            <Typography variant="body2" color={pmsColors.text.secondary}>
              <Box component="span" sx={{ fontWeight: 700, color: pmsColors.text.primary }}>
                {statistics.inHouse}
              </Box>{' '}
              Huespedes
            </Typography>
          </Stack>
        </>
      )}
    </Stack>
  );
}
